import classNames from 'classnames/bind';

import styles from './S02.module.scss';
import { IoChevronForward } from 'react-icons/io5';
import pulmuone_logo from '../../../assets/images/company/pulmuone/s02/pulmuone_logo.jpg';
import family_logo from '../../../assets/images/company/pulmuone/s02/family_logo.png';

const cx = classNames.bind(styles);

const S02 = () => {
  const moveToRecruit = () => {
    window.open('https://pulmuone.career.greetinghr.com/ko/apply');
  };

  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <div className={cx('family')}>
          <img src={family_logo} alt="가족친화 우수기업" />
          <div className={cx('text')}>
            <h3 className={cx('title')}>
              가족친화 우수기업 <span>‘풀무원샘물‘</span>
            </h3>
            <p>근로자와 기업, 사회의 상생을 위한 가족친화제도를 모범적으로 운영하는 기업입니다.</p>
            <div className={cx('button')} onClick={moveToRecruit}>
              <div className={cx('buttonText')}>채용공고 보러가기</div>
              <IoChevronForward size={28} color="#e62b86" />
            </div>
          </div>
        </div>
        <div className={cx('pulmuone')}>
          <img src={pulmuone_logo} alt="풀무원" />
          <div className={cx('text')}>
            <h3 className={cx('title')}>
              바른먹거리로 사람과 지구의 건강한 내일을 만드는 기업 <span>‘풀무원’</span>
            </h3>
            <p>
              풀무원은 ‘이웃사랑, 생명존중’의 풀무원 정신을 기반으로 ‘바른먹거리로 사람과 지구의 건강한 내일을 만드는 기업’이 되기 위해
              노력하고 있습니다. 우리는 바른먹거리를 만듭니다. 우리의 Value Chain 전 과정을 혁신하여 사람, 동물, 환경에 보다 이로운 방법을
              선택하고 개발합니다. 우리는 사람과 지구를 더 건강하게 만듭니다. 풀무원이 할 수 있는 최선의 노력, 최대의 실천을 통해 사람과
              지구의 건강한 내일을 만드는 것이 우리의 목적입니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default S02;
